import { render, staticRenderFns } from "./MemberCard.vue?vue&type=template&id=2359a0bf&scoped=true"
import script from "./MemberCard.vue?vue&type=script&lang=js"
export * from "./MemberCard.vue?vue&type=script&lang=js"
import style0 from "./MemberCard.vue?vue&type=style&index=0&id=2359a0bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2359a0bf",
  null
  
)

export default component.exports